import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';

import { Grid, Card } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Input, Spin, Select as SelectAntd } from 'antd';
import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';
import Button from '@components/Shared/Buttons/Button';
import { Search} from '@material-ui/icons';

import Services, {
  IGetAllProjetosTable,
  IRequestProjeto,
  IGetAllFundos
} from './services';

const columnsLabel = {
  id: 'ID',
  nome: 'Descrição',
};

const Projeto: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IGetAllProjetosTable[]>([]);
  const [formref] = Form.useForm();
  const [fundos, setFundos] = useState<IGetAllFundos[]>([]);
  const [fundoSelected, setFundoSelected] = useState<any>();

  const [loadingCreate, setLoadingCreate] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(false);

  async function loadGetAllProjetos() {
    setLoading(true);
    await api
      .get('/api/projetos/GetAll')
      .then(response => {
        const items = response.data;
        const itemData: IGetAllProjetosTable[] = items.map((item: any) => ({
          id: item.id,
          nome:item.nome,
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar(`Ocorreu um erro`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  }

  async function onSubmit(values: any) {
    setLoadingCreate(true);

    const createProjeto: IRequestProjeto = {
      nome: values.projeto,
      fundoId: values.fundo,
    };

    const service = new Services();
    const { error, response } = await service.CreateProjeto(createProjeto);

    setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      clearDados();
      setHabilitarBotao(false);

      loadGetAllProjetos();

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  async function loadGetAllFundos() {
    setLoading(true);

    const service = new Services();
    const { error, response } = await service.GetAllFundos();
    setFundos(response);

    setLoading(false);
  }

  const clearDados = () => {
    formref.setFieldsValue({
      projeto: '',
    });

    formref.setFieldsValue({
      fundo: '',
    });
  };

  async function loadGetProjetoByIdFundo() {
    setLoading(true);
    await api
      .get( `/api/projetos/GetProjetosByFundo?fundoId=${fundoSelected}`)

      .then(response => {
        const items = response.data;
        const itemData: IGetAllFundos[] = items.map((item: IGetAllFundos) => ({
          id: item.id,
          nome: item.nome,
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        alert(error);
      });
  }


  useEffect(() => {
    loadGetAllProjetos();
    loadGetAllFundos();
    window.document.title = 'CRM - Formas contribuições';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        {/* FORMULARIO  */}
        <Grid item lg={12} sm={12} xs={12}>
          <Spin
            size="large"
            spinning={loadingCreate}
            tip="Enviando dados..."
          >
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError={true}
              onFinish={onSubmit}
              labelAlign="left"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              requiredMark={false}
              initialValues={{

                dia_semana: '',
                horario: '',
              }}
            >

              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* Lista dos projetos cadastrados  */}
                <Grid container item lg={6} sm={6} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 550,  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
                  <Grid container
                      item
                      md={12}
                      lg={12}
                      xs={12}
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >

                      <Grid
                        item
                        md={8}
                        lg={8}
                        xs={12}
                        style={{
                          paddingRight: 5,
                          paddingLeft: 5,
                          //alignSelf: 'flex-end',
                          paddingTop: 10,
                        }}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                          placeholder="Fundo"
                          onChange={(e: any) => {setFundoSelected(e);}}
                        >
                          {fundos.map(item => (
                            <SelectAntd.Option key={item.id} value={item.id}>
                              {item.nome}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>

                      </Grid>

                      <Grid
                        item
                        md={2}
                        lg={2}
                        xs={12}
                        style={{
                          paddingRight: 5,
                          paddingLeft: 5,
                          //alignSelf: 'flex-end',
                          paddingTop: 10,
                        }}
                      >
                        <Button
                          color="secondary"
                          fullWidth
                          style={{
                            height: 32,
                          }}
                          onClick={loadGetProjetoByIdFundo}
                        >
                          <Search />
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
                    >

                      <TableCustomKeysNoPagination
                        loading={loading}
                        columns={[columnsLabel]}
                        FieldsBold={['nome']}
                        data={data}
                        keys={[
                          'id',
                          'nome',
                        ]}
                      />
                    </Grid>
                  </Card>
                </Grid>

                {/* Novo cadastro de projeto  */}
                <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item lg={10} md={10} xs={10} style={{ paddingLeft: 250, paddingRight: 5, alignSelf: 'end' }}>
                      <ButtonComponent
                        fullWidth
                        style={{ height: 46, borderRadius: 5}}
                        color={"secondary"}
                        onClick={() => {
                          setHabilitarBotao(true)
                        }}
                      >
                        Adicionar novo projeto
                      </ButtonComponent>
                    </Grid>

                    <Grid container>

                    <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="fundo" label="Fundo"
                          rules={[
                            {
                              required: true,
                              message: 'Selecione um fundo',
                            },
                          ]}
                        >
                          <SelectAntd
                            style={{ width: '100%' }}
                            disabled={habilitarBotao !== true}
                          >
                            {fundos.map(item => (
                              <SelectAntd.Option key={item.id} value={item.id}>
                                {item.nome}
                              </SelectAntd.Option>
                            ))}
                          </SelectAntd>
                        </Form.Item>
                      </Grid>

                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="projeto" label="Projeto"
                          rules={[
                            {
                              required: true,
                              message: 'Adicione um projeto',
                            },
                          ]}
                        >
                          <Input  disabled={habilitarBotao !== true}/>
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          disabled={habilitarBotao !== true}
                          onClick={clearDados}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                          disabled={habilitarBotao !== true}
                        >
                          Salvar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Projeto;
